import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { BulkActions } from "./bulk-actions";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceExportedInvoicesReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceExportedInvoices,
  endpoint: "report/finance-exported-invoices",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description:
      "Exported Invoices",
    url: "https://help.commonsku.com/knowledge/new-client-invoicing-report",
  },
  bulkActions: BulkActions,
};

export default FinanceExportedInvoicesReportConfig;
